<template>
    <div id="news-edu-mobile">
			<div class="main-content">
                <div class="header">
                    <div class="logo">
                        <a href="https://www.sankei.com/smp/nie/nie.html"><img src="../../assets/img/intro-common-manabou-logo.jpg" alt="newspaper education" loading="lazy"></a>
                    </div>
                    <div class="login-btn">
                        <a href="/create"><img src="../../assets/img/intro-common-login.jpg" alt="newspaper education" loading="lazy"></a>
                    </div>
                </div>
                <img src="../../assets/img/intro-sp-top.jpg" alt="newspaper education" style="margin-top:80px" width="100%" loading="lazy">
				<h3 class="titles">
					かんたん号外くんは、号外形式の新聞が簡単に作れるウェブアプリ。<br />
                    教育機関に無償提供しております。
                    （ご利用には産経新聞のご購読などの条件があります）
				</h3>
                <div class="news-edu-btn">
					<a class="btn-blue" href="https://id.sankei.jp/e/1697" target="blank">利用申請・お問い合わせ</a>
				</div>
                <div class="contact">
					<p>東京本社NIE担当　<a class="link" href="mailto:nie-tokyo@sankei.co.jp">nie-tokyo@sankei.co.jp</a></p>
                </div>
                <div class="subheading">
                    <div class="subheading-orange"></div>
                    <div class="subheading-txt">３つの特徴</div>
                </div>
                <div class="discription">
                    <div class="discription-txt">ウェブ上で記事や見出しを打ち込んで、すぐに号外が作れます</div>
                    <img src="../../assets/img/intro-common-feature01.jpg" alt="newspaper education" loading="lazy">
                </div>
                <div class="discription">
                    <div class="discription-txt">画像やPDFでダウンロードして、配布や印刷、クラスでの共有が簡単にできます</div>
                    <img src="../../assets/img/intro-common-feature02.jpg" alt="newspaper education" loading="lazy">
                </div>
                <div class="discription">
                    <div class="discription-txt">オリジナル新聞名が付けられます</div>
                    <img src="../../assets/img/intro-common-feature03.jpg" alt="newspaper education" loading="lazy">
                </div>
                <div class="subheading">
                    <div class="subheading-orange"></div>
                    <div class="subheading-txt">使い方</div>
                </div>
                <div class="discription">
                    <div class="discription-txt">記事の構成を学んで新聞を作ろう</div>                    
                </div>
                <div class="img-wrapper">
                    <img src="../../assets/img/intro-sp-use.jpg" alt="newspaper education" loading="lazy">
                </div>
                <div class="news-edu-btn">
					<a class="btn-blue" href="https://id.sankei.jp/e/1697" target="blank">利用申請・お問い合わせ</a>
				</div>
                <div class="contact">
					<p>東京本社NIE担当　<a class="link" href="mailto:nie-tokyo@sankei.co.jp">nie-tokyo@sankei.co.jp</a></p>
                </div>
                <div class="subheading">
                    <div class="subheading-orange"></div>
                    <div class="subheading-txt">育む力</div>
                </div>
                <div class="img-wrapper">
                    <img src="../../assets/img/intro-sp-hagukumu.jpg" alt="newspaper education" loading="lazy">
                </div>
                <div class="subheading">
                    <div class="subheading-orange"></div>
                    <div class="subheading-txt">活用例</div>
                </div>
                <div class="img-wrapper">
                    <img src="../../assets/img/intro-sp-katsuyou.jpg" alt="newspaper education" loading="lazy">
                </div>
                <div class="subheading">
                    <div class="subheading-orange"></div>
                    <div class="subheading-txt">現場の声</div>
                </div>
                <div class="discription">出来上がりの達成感に笑顔</div>
                <p>近畿大学附属中学校（大阪府東大阪市）</p>
                <div class="img-wrapper">
                    <img src="../../assets/img/intro-common-voice-class.jpg" alt="newspaper education" loading="lazy">
                </div>
                <div class="teacher-txt">
                   産経新聞大阪本社編集企画室の教育チームが継続的な出前授業を行っている、2年生約290人が夏休みの課題として「オリジナル号外」作りにチャレンジ。アプリを使って、産経新聞電子版から気になった記事を引き写してまとめました。
                </div>
                <div class="discription">片木真也教諭（総合表現）</div>
                <div class="teacher">
                    <img src="../../assets/img/intro-common-voice-teacher.jpg" alt="newspaper education" width="70%" loading="lazy">
                    <div class="teacher-txt">
                       「電子データになる、きれいな新聞の形式になる、ということは生徒の達成感も大きく、また保護者からも驚きの声が聞かれました」
                    </div>
                </div>
    			<div class="news-edu-btn" style="margin-top:40px;">
					<router-link to="/create"  class="btn-blue">
						ログイン
					</router-link>
				</div>
			</div>


    </div>
</template>

<script>
    export default {
        name: "NewspaperEducationMobile",
        data() {
            return {
                URL: 'https://www.sankei.com/smp/nie/create-newspaper/'
            }
        },
    }
</script>

<style scoped lang="scss">
    #news-edu-mobile {
        .contact {
            p {
                font-weight: bold;
                a {
                    color:#1C7CD5;
                }
            }
        }

        .header {
            position: fixed;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 80px;
            margin-right: 15px;
            background-color: #ffffff;
            box-shadow: 0px 1px 0px #06517b;
            .logo {
                position: absolute;
                left: 50%;
                margin-top: 5px;
                img {
                    margin-left: -35px;
                    width: 70px;
                }
            }
            .login-btn {
                position: absolute;
                margin-top: 5px;
                right: 5%;
                img {
                    height: 60px;
                }
            }
        }

        .subheading {
            text-align: center;
            margin: 10px auto;
            width: 60%;
            line-height: 40px;
            white-space: nowrap;
            &-orange {
                float: left;
                background-color: #febf33;
                width: 10px;
                height: 40px;
            }
            &-txt {
                float: left;
                background-color: #fedc43;
                font-weight: bold;
                font-size: 22px;
                width: calc(100% - 10px);
            }
       }

       .discription {
           margin: 30px auto 20px;
           text-align: center;
           font-weight: bold;
           font-size: 18px;
           text-align: center;
           height: 100%;
           width: 100%;
           &-txt {
               width: 85%;
               margin: 0 auto;
               text-align: center;
               line-height: 36px;
           }
           img {
               width: 70%;
               max-width: 300px;
           }
       }

       .img-wrapper {
            text-align:center;
            margin:20px 0 40px;
            img {
                width: 100%;
                max-width: 600px;
            }
       }

        .news-edu-tab {
            a {
                &:hover {
                    color: rgba(28, 124, 213, .7);
                }
            }
        }

        .btn {
            width: 100%;

            .btn-blue {
                border-radius: 4px;
                background-color: #1C7CD5;
                padding: 10px 50px;
                cursor: pointer;
								color: #ffffff;

                &:hover {
                    color: #fff;
                }
            }
        }

        .teacher {
            margin: 0 auto;
            width: 100%;
            height: 100%;
            text-align: center;
            img {
                width: 50%;
                max-width: 300px;
                margin-bottom: 20px;
            }
            &-txt {
               width: 90%;
               max-width: 600px;
               margin: 0 auto;
               text-align: left;
           }
        }
    }
</style>